import common from "@/store/common/module/common";
import corpService from "@/store/common/module/CorpService";

const util = {
  decodePolyline(encoded) {
    if (encoded == null || encoded.length == 0) return null;

    let polylineStartTime;
    const withSpeed = encoded.startsWith("AAB");
    if (encoded.startsWith("AAA") || encoded.startsWith("AAB")) {
      polylineStartTime = parseInt(
        encoded.substring(3, encoded.indexOf("==="))
      );
      encoded = encoded.substring(encoded.indexOf("===") + 3);
    }

    // array that holds the points

    const points = [];
    let index = 0;
    const len = encoded.length;
    let lat = 0,
      lng = 0;
    let tym = 0;
    let speed;
    while (index < len) {
      let b,
        shift = 0,
        result = 0;
      do {
        b = encoded.charAt(index++).charCodeAt(0) - 63; //finds ascii                                                                                    //and substract it by 63
        result |= (b & 0x1f) << shift;
        shift += 5;
      } while (b >= 0x20);

      const dlat = (result & 1) != 0 ? ~(result >> 1) : result >> 1;
      lat += dlat;

      if (index === len) break;

      shift = 0;
      result = 0;
      do {
        b = encoded.charAt(index++).charCodeAt(0) - 63;
        result |= (b & 0x1f) << shift;
        shift += 5;
      } while (b >= 0x20);

      const dlng = (result & 1) != 0 ? ~(result >> 1) : result >> 1;
      lng += dlng;

      if (polylineStartTime != null) {
        shift = result = 0;
        do {
          b = encoded.charAt(index++).charCodeAt(0) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        const dtym = (result & 1) != 0 ? ~(result >> 1) : result >> 1;
        tym = dtym;
      }

      if (withSpeed != null) {
        shift = result = 0;
        do {
          b = encoded.charAt(index++).charCodeAt(0) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        const dtym = (result & 1) != 0 ? ~(result >> 1) : result >> 1;
        speed = dtym;
      }

      const polylineLoc = {};
      polylineLoc.lat = lat / 1e5;
      polylineLoc.lng = lng / 1e5;
      if (polylineStartTime != null) {
        polylineLoc.time = polylineStartTime + tym;
        if (speed != null && speed != -1) {
          polylineLoc.speed = speed * 3.6;
        }
      }

      points.push(polylineLoc);
    }
    return points;
  },

  roundCurrency(value) {
    if (value == null) return null;
    const div = 100.0;

    if (div == 0 || div == 1) return Math.round(value);

    return Math.round(value * div) / div;
  },

  roundZero(value) {
    if (value == null) return null;
    return Math.round(value);
  },

  roundCurrency2Decimal(value) {
    if (value == null) return null;
    return value.toFixed(2);
  },

  isUnionTerritory(state) {
    if (state == null) return false;
    if (
      state == "Delhi" ||
      state == "Chandigarh" ||
      state == "Dadra and Nagar Haveli" ||
      state == "Daman and Diu" ||
      state == "Lakshadweep" ||
      state == "Andaman and nicobar islands" ||
      state == "Puducherry"
    ) {
      return true;
    }
    return false;
  },

  percentage(value, percentage) {
    return value * percentage * 0.01;
  },

  async calculateFare(tripInvoice, taxSlab) {
    if (!tripInvoice) return;
    await this.calculateCompleteFare(
      tripInvoice.fare,
      taxSlab
    );
  },

  async calculateCompleteFare(fare, taxSlab) {
    if (!fare) return;
    // let subTotal = 0;
    // let totalTaxes = 0;
    // let totalDiscounts = 0;
    for (let i = 0; i < fare.charges.length; i++) {
      if (
        fare.charges[i] &&
        fare.charges[i].items &&
        fare.charges[i].items.length > 0
      ) {
        for (let _i = 0; _i < fare.charges[i].items.length; _i++) {
          if (
            !isNaN(fare.charges[i].items[_i].units) &&
            !isNaN(fare.charges[i].items[_i].unitCost) &&
            fare.charges[i].items[_i].unitCost !== "" &&
            fare.charges[i].items[_i].units !== ""
          ) {
            fare.charges[i].items[_i].amount =
              parseFloat(fare.charges[i].items[_i].unitCost) *
              parseFloat(fare.charges[i].items[_i].units);
          } else {
            fare.charges[i].items[_i].amount = 0;
          }
        }
      }
    }
    await this.calculateTaxesAndDiscounts(fare);

    // await this.getTaxesOnChargesWithoutTaxItem(
    //   fare.charges,
    //   fare.taxes,
    //   taxSlab
    // );

    // for (let i = 0; i < fare.charges.length; i++) {
    //   if (fare.charges[i].items && fare.charges[i].items.length > 0) {
    //     for (let _i = 0; _i < fare.charges[i].items.length; _i++) {
    //       if (
    //         fare.charges[i].items[_i] &&
    //         fare.charges[i].items[_i].amount &&
    //         !isNaN(fare.charges[i].items[_i].amount)
    //       ) {
    //         subTotal = subTotal + parseFloat(fare.charges[i].items[_i].amount);
    //       }
    //     }
    //   }
    // }
    // for (let i = 0; i < fare.discounts.length; i++) {
    //   if (fare.discounts[i].amount && !isNaN(fare.discounts[i].amount))
    //     totalDiscounts = totalDiscounts + parseFloat(fare.discounts[i].amount);
    // }
    // for (let i = 0; i < fare.taxes.length; i++) {
    //   if (fare.taxes[i].amount && !isNaN(fare.taxes[i].amount))
    //     totalTaxes = totalTaxes + parseFloat(fare.taxes[i].amount);
    // }
    // fare.totalTaxes = this.roundCurrency(parseFloat(totalTaxes));
    // fare.totalDiscounts = this.roundZero(parseFloat(totalDiscounts));
    // fare.subTotal = this.roundZero(
    //   parseFloat(subTotal) - parseFloat(totalDiscounts)
    // );
    // fare.total = this.roundZero(fare.subTotal + fare.totalTaxes);
  },

  async calculateTaxesAndDiscounts(fare) {
    if (!fare || !fare.charges) return;
    const taxes = [];
    const discounts = [];
    for (const i in fare.charges) {
      const item = fare.charges[i];
      let amount = 0;

      if (item && item.items && item.items.length > 0) {
        for (let _i = 0; _i < item.items.length; _i++) {
          if (
            item.items &&
            item.items[_i] &&
            item.items[_i].units &&
            !isNaN(item.items[_i].units) &&
            item.items[_i].unitCost &&
            !isNaN(item.items[_i].unitCost)
          ) {
            amount =
              amount +
              parseFloat(item.items[_i].units) *
                parseFloat(item.items[_i].unitCost);
          }
        }
      }

      let totalDiscount = 0;
      if (item.discounts != null && item.discounts.length > 0) {
        for (let j = 0; j < item.discounts.length; j++) {
          const disc = item.discounts[j];

          let newItem = null;
          for (const t in discounts) {
            if (discounts[t].name != null && discounts[t].name == disc.name) {
              newItem = discounts[t];
              break;
            }
          }

          if (newItem == null) {
            newItem = {
              name: disc.name,
              amount: 0,
            };
          }

          if (disc.amount && !isNaN(disc.amount)) {
            totalDiscount = totalDiscount + parseFloat(disc.amount);
            newItem.amount =
              parseFloat(newItem.amount) + parseFloat(disc.amount);
          }

          discounts.push(newItem);
        }
      }

      if (item.taxItem != null && item.taxItem.tax_id != null) {
        let slab = item.taxItem.taxDetail;
        if (!slab) {
          await corpService.populateTaxes();
          const _taxeSlabs = await corpService.taxes["self"];
          if (_taxeSlabs) {
            for (let _ind = 0; _ind < _taxeSlabs.length; _ind++) {
              if (_taxeSlabs[_ind]._id == item.taxItem.tax_id) {
                slab = _taxeSlabs[_ind];
                break;
              }
            }
          }
        }
        if (slab != null) {
          const taxObj = await this.getTaxBreakupObj(
            slab,
            amount - totalDiscount
          );
          item.taxItem.tax_id = taxObj.tax_id;
          item.taxItem.taxes = taxObj.taxes;

          if (item.taxItem.taxes != null) {
            for (const j in item.taxItem.taxes) {
              const tax = item.taxItem.taxes[j];
              let newItem = null;
              for (const k in taxes) {
                const t = taxes[k];
                if (t.name == tax.name) {
                  newItem = t;
                  break;
                }
              }
              if (newItem == null) {
                newItem = {
                  name: tax.name,
                  desc: tax.desc,
                  amount: 0,
                };

                newItem.amount = this.roundCurrency(
                  parseFloat(newItem.amount) + parseFloat(tax.amount)
                );
                taxes.push(newItem);
              } else {
                newItem.amount = this.roundCurrency(
                  parseFloat(newItem.amount) + parseFloat(tax.amount)
                );
              }
            }
          }
        }
      }
    }
    fare.taxes = taxes;
    fare.discounts = discounts;
  },


  async getTaxesOnChargesWithoutTaxItem(
    items,
    taxes,
    slab
  ) {
    if (slab == null || slab.amount == null) return;
    if (items && items.length > 0) {
      for (const i in items) {
        const item = items[i];
        let amount = 0;

        if (item && item.items && item.items.length > 0) {
          for (let _i = 0; _i < item.items.length; _i++) {
            if (
              item.items &&
              item.items[_i] &&
              item.items[_i].units &&
              !isNaN(item.items[_i].units) &&
              item.items[_i].unitCost &&
              !isNaN(item.items[_i].unitCost)
            ) {
              amount =
                amount +
                parseFloat(item.items[_i].units) *
                  parseFloat(item.items[_i].unitCost);
            }
          }
        }

        let totalDiscount = 0;
        if (item.discounts != null && item.discounts.length > 0) {
          for (let k = 0; k < item.discounts.length; k++) {
            const element = item.discounts[k];
            if (
              element != null &&
              element.amount != null &&
              parseFloat(element.amount) > 0
            ) {
              totalDiscount = totalDiscount + parseFloat(element.amount);
            }
          }
        }
        if (item.taxItem == null || item.taxItem.tax_id == null) {
          item.taxItem = {};
          const taxObj = await this.getTaxBreakupObj(
            slab,
            amount - totalDiscount
          );
          item.taxItem.tax_id = taxObj.tax_id;
          item.taxItem.taxes = taxObj.taxes;

          if (item.taxItem.taxes != null) {
            for (const j in item.taxItem.taxes) {
              const tax = item.taxItem.taxes[j];
              let newItem = null;
              for (const k in taxes) {
                const t = taxes[k];
                if (t.name == tax.name) {
                  newItem = t;
                  break;
                }
              }
              if (newItem == null) {
                newItem = {
                  name: tax.name,
                  desc: tax.desc,
                  amount: 0,
                };
                newItem.amount = newItem.amount + tax.amount;
                taxes.push(newItem);
              } else {
                newItem.amount = newItem.amount + tax.amount;
              }
            }
          }
        }
      }
    }
  },


  async getTaxBreakup(taxSlab, subTotal) {
    const taxes = [];

    if (taxSlab.taxItems != null && taxSlab.taxItems.length != 0) {
      for (const i in taxSlab.taxItems) {
        const taxItem = taxSlab.taxItems[i];
        const item = {};
        item.name = taxItem.title;
        if (taxItem.isAbs != null && taxItem.isAbs) {
          item.amount = taxItem.amount;
          item.desc = taxItem.amount.toString();
        } else {
          item.amount = this.roundZero(
            this.percentage(subTotal, taxItem.amount)
          );
          item.desc = taxItem.amount.toString() + "%";
        }
        taxes.push(item);
      }
      return taxes;
    }

    if (0 == taxSlab.amount) {
      const item = {};
      item.name = "IGST";
      item.amount = 0.0;
      item.desc = "0%";
      taxes.push(item);
      return taxes;
    }

    return taxes;
  },

  async getTaxBreakupObj(taxSlab, subTotal) {
    const taxObj = { tax_id: null, taxes: null };
    const taxes = [];

    if (taxSlab.taxItems != null && taxSlab.taxItems.length != 0) {
      for (const i in taxSlab.taxItems) {
        const taxItem = taxSlab.taxItems[i];
        const item = {};
        item.name = taxItem.title;
        if (taxItem.isAbs != null && taxItem.isAbs) {
          item.amount = taxItem.amount;
          item.desc = taxItem.amount.toString();
        } else {
          item.amount = this.roundZero(
            this.percentage(subTotal, taxItem.amount)
          );
          item.desc = taxItem.amount.toString() + "%";
        }
        taxes.push(item);
      }
      taxObj.tax_id = taxSlab._id;
      taxObj.taxes = taxes;
      return taxObj;
    }

    if (0 == taxSlab.amount) {
      const item = {};
      item.name = "IGST";
      item.amount = 0.0;
      item.desc = "0%";
      taxes.push(item);

      taxObj.tax_id = taxSlab._id;
      taxObj.taxes = taxes;
      return taxObj;
    }

    taxObj.tax_id = taxSlab._id;
    taxObj.taxes = taxes;

    return taxObj;
  },

  itemAmtSum(taxes) {
    if (!taxes || taxes.length == 0) return 0;
    let sum = 0;
    for (const i in taxes) {
      sum = sum + taxes[i].amount;
    }
    return sum;
  },

  getFuelTypeList() {
    return [
      {
        name: "Petrol",
        value: "Petrol",
      },
      {
        name: "CNG",
        value: "CNG",
      },
      {
        name: "LPG",
        value: "LPG",
      },
      {
        name: "Diesel",
        value: "Diesel",
      },
      {
        name: "Electric",
        value: "Electric",
      },
    ];
  },

  getColorsList() {
    return [
      {
        name: "White",
        value: "white",
      },
      {
        name: "Red",
        value: "red",
      },
      {
        name: "Blue",
        value: "blue",
      },
      {
        name: "Yellow",
        value: "yellow",
      },
      {
        name: "Black",
        value: "black",
      },
      {
        name: "Silver",
        value: "silver",
      },
      {
        name: "Orange",
        value: "orange",
      },
      {
        name: "Grey",
        value: "grey",
      },
      {
        name: "Multi",
        value: "multi",
      },
    ];
  },
};

export const CommonUtil = util;
